import React from "react"
import BillingHistoryTable from '../../../../utility/table/BillingHistoryTable.jsx'
import SearchBar from "./BillingHistorySearch.jsx";
import { billingInvoiceTableData } from "../../Common/Datatable.jsx";

const BillingHistory = () => {

  const { tableId, ajaxUrl, columns } = billingInvoiceTableData;
  return (
    <div className="mb-4 kpi-section">
      {/* <SearchBar/> */}

      <BillingHistoryTable  tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} />

    </div>
  )
};

export default BillingHistory;